import React, { useEffect } from "react";
import {
    FaArrowLeft,
    FaBell,
    FaEllipsisH,
    FaChartLine,
    FaBullseye,
    FaSignal,
    FaUsers,
    FaChartBar,
    FaShieldAlt,
    FaTrophy,
    FaEnvelope,
    FaPhone,
} from "react-icons/fa";
import { useContext } from "react";
import { SafeAreaContext } from "../../../App";

const TradeSignalPage = () => {
 //safArea for Pwa////////
const { setSafeAreaColor } = useContext(SafeAreaContext);

useEffect(() => {
  setSafeAreaColor({ background: "#FFFFFF" });
}, []);
////////////////////////
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: "0px 0px -50px 0px",
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = "1";
                    entry.target.style.transform = "translateY(0)";
                }
            });
        }, observerOptions);

        document.querySelectorAll(".feature-card").forEach((card) => {
            card.style.opacity = "0";
            card.style.transform = "translateY(20px)";
            card.style.transition = "all 0.6s ease";
            observer.observe(card);
        });
    }, []);

    return (
        <div className="bg-gray-50 font-sans">
            {/* Header */}
            <header className="bg-white px-4 py-4 fixed top-0 left-0 right-0 shadow-sm z-50">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <button
                            onClick={() => window.history.back()}
                            className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors"
                        >
                            <FaArrowLeft className="text-gray-600" />
                        </button>
                        <h1 className="text-xl font-bold text-gray-900">About Us</h1>
                    </div>
                    <div className="flex items-center space-x-3">
                        <button className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors">
                            <FaBell className="text-orange-500" />
                        </button>
                        <button className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 transition-all duration-200">
                            <FaEllipsisH className="text-gray-600" />
                        </button>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="pt-20 pb-20">
                {/* Hero Section */}
                <section className="bg-gradient-to-tr from-[#667eea] to-[#764ba2] text-white py-16 px-5">
                    <div className="max-w-md mx-auto text-center">
                        <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
                            <FaChartLine className="text-3xl text-white" />
                        </div>
                        <h1 className="text-3xl font-bold mb-4">Trade Signal Navigator</h1>
                        <p className="text-lg opacity-90 leading-relaxed">
                            Your trusted companion in the world of trading signals and
                            financial markets
                        </p>
                    </div>
                </section>

                {/* Mission Section */}
                <section className="px-5 py-12">
                    <div className="max-w-md mx-auto text-center mb-8">
                        <div className="w-16 h-16 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
                            <FaBullseye className="text-2xl text-indigo-400" />
                        </div>
                        <h2 className="text-2xl font-bold text-gray-900 mb-3">
                            Our Mission
                        </h2>
                        <p className="text-gray-600 leading-relaxed">
                            We aim to democratize trading by providing accessible, reliable,
                            and professional trading signals to traders of all levels.
                        </p>
                    </div>
                </section>

                {/* Features Section */}
                <section className="px-5 py-8 bg-white">
                    <div className="max-w-md mx-auto">
                        <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">
                            What We Offer
                        </h2>

                        <div className="space-y-6">
                            <div className="feature-card bg-blue-50 p-6 rounded-xl border border-blue-100">
                                <div className="flex items-start space-x-4">
                                    <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                        <FaSignal className="text-white text-lg" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-900 mb-2">
                                            Real-time Signals
                                        </h3>
                                        <p className="text-gray-600 text-sm leading-relaxed">
                                            Get instant notifications for trading opportunities with
                                            precise entry points, take profits, and stop losses.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-card bg-green-50 p-6 rounded-xl border border-green-100">
                                <div className="flex items-start space-x-4">
                                    <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                        <FaUsers className="text-white text-lg" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-900 mb-2">
                                            Expert Traders
                                        </h3>
                                        <p className="text-gray-600 text-sm leading-relaxed">
                                            Follow verified professional traders with proven track
                                            records.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-card bg-purple-50 p-6 rounded-xl border border-purple-100">
                                <div className="flex items-start space-x-4">
                                    <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                        <FaChartBar className="text-white text-lg" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-900 mb-2">
                                            Market Analysis
                                        </h3>
                                        <p className="text-gray-600 text-sm leading-relaxed">
                                            Comprehensive insights covering Forex, Crypto, Stocks, and
                                            Commodities.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-card bg-orange-50 p-6 rounded-xl border border-orange-100">
                                <div className="flex items-start space-x-4">
                                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
                                        <FaShieldAlt className="text-white text-lg" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-lg text-gray-900 mb-2">
                                            Risk Management
                                        </h3>
                                        <p className="text-gray-600 text-sm leading-relaxed">
                                            Built-in tools and educational resources to help you trade
                                            responsibly.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="px-5 py-12 bg-gray-900 text-white">
                    <div className="max-w-md mx-auto">
                        <h2 className="text-2xl font-bold text-center mb-8">Our Impact</h2>
                        <div className="grid grid-cols-2 gap-6">
                            <div className="text-center">
                                <div className="w-16 h-16 bg-indigo-400 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                                    <FaUsers className="text-2xl text-indigo-400" />
                                </div>
                                <h3 className="text-3xl font-bold">50K+</h3>
                                <p className="text-gray-300 text-sm">Active Traders</p>
                            </div>
                            <div className="text-center">
                                <div className="w-16 h-16 bg-green-500 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                                    <FaChartLine className="text-2xl text-green-400" />
                                </div>
                                <h3 className="text-3xl font-bold">85%</h3>
                                <p className="text-gray-300 text-sm">Success Rate</p>
                            </div>
                            <div className="text-center">
                                <div className="w-16 h-16 bg-yellow-500 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                                    <FaBullseye className="text-2xl text-yellow-400" />
                                </div>
                                <h3 className="text-3xl font-bold">1M+</h3>
                                <p className="text-gray-300 text-sm">Signals Delivered</p>
                            </div>
                            <div className="text-center">
                                <div className="w-16 h-16 bg-blue-500 bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-3">
                                    <FaTrophy className="text-2xl text-blue-400" />
                                </div>
                                <h3 className="text-3xl font-bold">200+</h3>
                                <p className="text-gray-300 text-sm">Expert Traders</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Team Section */}
                <section className="px-5 py-12">
                    <div className="max-w-md mx-auto">
                        <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">
                            Our Team
                        </h2>
                        <div className="space-y-6">
                            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex items-center space-x-4">
                                <img
                                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg"
                                    alt="CEO"
                                    className="w-16 h-16 rounded-full"
                                />
                                <div>
                                    <h3 className="font-bold text-lg text-gray-900">Ahmad Rezaei</h3>
                                    <p className="text-indigo-400 font-semibold">CEO & Founder</p>
                                    <p className="text-gray-600 text-sm mt-1">
                                        15+ years in financial markets
                                    </p>
                                </div>
                            </div>

                            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex items-center space-x-4">
                                <img
                                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg"
                                    alt="CTO"
                                    className="w-16 h-16 rounded-full"
                                />
                                <div>
                                    <h3 className="font-bold text-lg text-gray-900">Sara Ahmadi</h3>
                                    <p className="text-indigo-400 font-semibold">Head of Analysis</p>
                                    <p className="text-gray-600 text-sm mt-1">
                                        Expert in technical analysis
                                    </p>
                                </div>
                            </div>

                            <div className="bg-white p-6 rounded-xl shadow-lg border border-gray-100 flex items-center space-x-4">
                                <img
                                    src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg"
                                    alt="Lead Developer"
                                    className="w-16 h-16 rounded-full"
                                />
                                <div>
                                    <h3 className="font-bold text-lg text-gray-900">Ali Hosseini</h3>
                                    <p className="text-indigo-400 font-semibold">Lead Developer</p>
                                    <p className="text-gray-600 text-sm mt-1">
                                        Platform architecture specialist
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Contact Section */}
                <section className="px-5 py-12 bg-indigo-400 text-white">
                    <div className="max-w-md mx-auto text-center">
                        <h2 className="text-2xl font-bold mb-6">Get In Touch</h2>
                        <p className="text-lg opacity-90 mb-8 leading-relaxed">
                            Have questions or suggestions? We'd love to hear from you.
                        </p>

                        <div className="space-y-4 mb-8">
                            <div className="flex items-center justify-center space-x-3">
                                <FaEnvelope className="text-xl" />
                                <span className="text-lg">support@tradesignals.com</span>
                            </div>

                            <div className="flex items-center justify-center space-x-3">
                                <FaPhone className="text-xl" />
                                <span className="text-lg">+1 (555) 123-4567</span>
                            </div>
                        </div>

                        <button className="bg-white text-indigo-400 px-8 py-3 rounded-xl font-bold hover:bg-gray-100 transition-colors">
                            Contact Support
                        </button>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default TradeSignalPage;
